import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:frame-load', () => {
      // Scroll only on small screens
      if (window.innerWidth >= 768) return

      // If some element has focus (i.e., not BODY) → do not scroll
      const active = document.activeElement
      if (active && active.tagName !== 'BODY') return

      // Smooth scroll this element into view (block 'start' ensures top of element is visible)
      this.element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }
}
